import { useHistory } from 'react-router-dom';
import { Button, Fade, Grid, Hidden, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import ErrorLayout from 'layouts/error-layout';

const useStyles = makeStyles((theme) => ({
  div: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'left',
    margin: 'auto',
  },
  root: {
    display: 'flex',
  },
  text: { marginBotton: '15px' },
  button: {
    marginTop: '50px',
    background: theme.palette.secondary.main,
    borderRadius: '2px',
    paddingRight: '25px',
    paddingLeft: '25px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
}));

export default function ErrorPage() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <ErrorLayout>
      <Fade in={true}>
        <div className={classes.div}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            className={classes.root}
            spacing={10}
          >
            <Grid item sm={12} md={6}>
              <Typography variant="h3" style={{ paddingBottom: '25px' }}>
                Something went wrong.
              </Typography>
              <Typography>
                We're sorry. It looks like something went wrong. Please let your Concierge know if
                the problem persists.
              </Typography>
              <Button className={classes.button} onClick={() => history.push('/home')}>
                Back to home
              </Button>
            </Grid>
            <Hidden mdDown>
              <Grid item sm={6}>
                <img src="/error-image.svg" alt="Error" />
              </Grid>
            </Hidden>
          </Grid>
        </div>
      </Fade>
    </ErrorLayout>
  );
}
